import React from 'react';
import { Divider, NumberInput, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { KlaviyoTestFormValues } from './KlaviyoTestFormTypes';

export type PaymentFieldsProps = {
	form: UseFormReturnType<KlaviyoTestFormValues>;
	disabled: boolean;
};

export function PaymentFields(props: PaymentFieldsProps) {
	const { form, disabled } = props;

	return (
		<>
			<Divider label="Payment" />
			<TextInput
				{...form.getInputProps('paymentId')}
				label="Payment ID"
				description="Paste the ID of an existing Payment row"
				withAsterisk
				disabled={disabled}
			/>
			<TextInput {...form.getInputProps('invoiceDownloadUrl')} label="Invoice download URL" disabled={disabled} />
		</>
	);
}

export function PaymentFailureFields(props: PaymentFieldsProps) {
	const { form, disabled } = props;

	return (
		<>
			<Divider label="Payment failure details" />
			<NumberInput {...form.getInputProps('paymentAmountInCents')} label="Amount (cents)" disabled={disabled} />
			<TextInput {...form.getInputProps('paymentCurrency')} label="Currency" disabled={disabled} />
			<TextInput {...form.getInputProps('accountUrl')} label="Account URL" disabled={disabled} />
		</>
	);
}
